<template>
  <aside class="float-aside" aria-label="快捷联系">
    <div class="float-aside__row">
      <button type="button" class="float-aside__item" title="电话咨询" aria-label="电话咨询">☎</button>
      <div class="float-aside__panel">0527-88266855</div>
    </div>

    <div class="float-aside__row">
      <button type="button" class="float-aside__item" title="邮件联系" aria-label="邮件联系">✉</button>
      <div class="float-aside__panel">772919504@qq.com</div>
    </div>

    <div class="float-aside__row">
      <button type="button" class="float-aside__item" title="微信咨询" aria-label="微信咨询">
        <img src="@/assets/weixin.png" alt="微信图标" class="float-aside__wechat-icon">
      </button>
      <div class="float-aside__panel float-aside__panel--qr">
        <img src="@/assets/ewm.png" alt="微信二维码" class="float-aside__qr">
      </div>
    </div>

    <button type="button" class="float-aside__item float-aside__top" title="回到顶部" @click="scrollTop">↑</button>
  </aside>
</template>

<script>
export default {
  name: 'FloatingAside',
  methods: {
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.float-aside {
  position: fixed;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 900;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.float-aside__row {
  position: relative;
}

.float-aside__item {
  width: 64px;
  height: 64px;
  border: 1px solid #cbd5e1;
  border-top-width: 0;
  background: #fff;
  color: #0ea5e9;
  font-size: 32px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: none;
  transition: color 0.2s, background 0.2s;
  position: relative;
  z-index: 2;
}

.float-aside__row:first-child .float-aside__item {
  border-top-width: 1px;
}

.float-aside__item:hover {
  color: #0284c7;
  background: #f8fbff;
}

.float-aside__panel {
  position: absolute;
  right: 64px;
  top: 0;
  height: 64px;
  min-width: 220px;
  padding: 0 18px;
  background: #0ea5e9;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 32px;
  line-height: 1;
  white-space: nowrap;
  border: 1px solid #0ea5e9;
  opacity: 0;
  visibility: hidden;
  transform: translateX(8px);
  transition: opacity 0.2s, transform 0.2s, visibility 0.2s;
}

.float-aside__row:hover .float-aside__panel,
.float-aside__row:focus-within .float-aside__panel {
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
}

.float-aside__panel--qr {
  width: 210px;
  height: 210px;
  min-width: 210px;
  padding: 10px;
  align-items: center;
  justify-content: center;
}

.float-aside__qr {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background: #fff;
}

.float-aside__top {
  height: 52px;
  font-weight: 700;
  font-size: 34px;
  border-top-width: 0;
}

.float-aside__wechat-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: block;
}

@media (max-width: 900px) {
  .float-aside {
    right: 8px;
    top: auto;
    bottom: 100px;
    transform: none;
  }

  .float-aside__item {
    width: 52px;
    height: 52px;
    font-size: 26px;
  }

  .float-aside__panel {
    right: 52px;
    height: 52px;
    min-width: 170px;
    font-size: 24px;
    padding: 0 14px;
  }

  .float-aside__panel--qr {
    width: 170px;
    height: 170px;
    min-width: 170px;
    padding: 8px;
  }

  .float-aside__top {
    height: 42px;
    font-size: 28px;
  }

  .float-aside__wechat-icon {
    width: 20px;
    height: 20px;
  }
}
</style>
